<template>
  <div class="section-about-web">
      <div class="container">
        <div class="about-web__row row">
          <div class="col-3">
            <div>
              <h2 class="about-project__h2-title color-white">Um vefinn</h2>
              <ul class="about-web__list">
                <li class="about-web__list-item">
                  <span class="title">Fyrir kaupendur</span>
                  <p class="text">Allir verðlistar á einum stað í gagnagrunni sem einfaldar leit, auðveldar framboð og bætir upplifun notenda bílaumboða.</p>
                </li>
                <li class="about-web__list-item">
                  <span class="title">Fyrir bílaumboð</span>
                  <p class="text">Við höfum sérsmíðað öflugt tæki til að greina eftirspurn ökutækja og ná beinni snertingu við skráða notendur sem fylgjast með verði og verðbreytingum ákveðinna tegunda.</p>
                </li>
              </ul>
              <div class="about-web__author row">
                <div class="about-web__author-logo">
                  <img :src="`${imgURL}author.png`" alt="">
                </div>
                <div class="about-web__author-bio">
                  <span class="title">Dimitri Plugari</span>
                  <span class="subtitle">Eigandi / Viðmótshönnuður</span>
                  <p class="text">Vefur og kerfi er forritað af <a class="link" href="https://www.mango.is" target="_blank">www.mango.is</a></p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-9">
            <div class="about-web__img">
              <img :src="`${imgURL}macbook-pro.png`" alt="macbook-pro">
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    imgURL: {
      type: String,
      default: ''
    }
  }
}
</script>